import styled from "styled-components";
import { MediatorDataContainer } from "../../common/mediator-styles";

export const SaludPymesMediatorContainer = styled(MediatorDataContainer)``;
